import React from 'react';
import styles from './PillsContainer.module.css';

export type PillsContainerItem = {
  id: string;
  label: string;
  fullLabel: string;
};

type PillsContainerProps = {
  items: PillsContainerItem[];
  onClick: (id: PillsContainerItem) => void;
};

const PillsContainer = ({ items, onClick }: PillsContainerProps) => {
  return (
    <div className={styles.wrap}>
      <div className={styles.labelRow}>
        <span className={styles.spark} aria-hidden>
          <img src="/img/logo.png" alt="" />
        </span>
        <span className={styles.label}>Suggested prompts</span>
      </div>
      <div className={styles.container} role="list">
        {items.map((item) => (
          <button
            key={item.id}
            type="button"
            role="listitem"
            className={styles.pill}
            title={item.fullLabel}
            onClick={() => onClick?.(item)}
          >
            <span className={styles.pillText}>{item.label}</span>
            <span className={styles.pillArrow} aria-hidden>
              <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.75">
                <path d="M2.5 6h7M6.5 3.5L9.5 6 6.5 8.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default PillsContainer;
